import React from 'react'
import styled from 'styled-components'
import { Box } from '../../../../../core-components'
import { ThemeColors, ThemeShadows } from '../../../../../theme'

type Props = {
  isDisabled?: boolean
  isFocused?: boolean
  isSelected: boolean
}

export const Radio = ({ isSelected, isDisabled = false, isFocused = false }: Props) => {
  return (
    <Box
      aria-hidden
      w={4}
      h={4}
      position='relative'
      borderRadius='full'
      flexShrink={0}
      boxShadow={getRadioShadow(isFocused)}
      bg={getRadioBackground(isSelected, isDisabled)}
    >
      {!isSelected && (
        <Box
          as='svg'
          xmlns='http://www.w3.org/2000/svg'
          w={4}
          h={4}
          color={isDisabled ? 'bg/select-item-unchecked-disabled' : 'bg/select-item-unchecked'}
        >
          <path
            fill='currentColor'
            fillRule='evenodd'
            d='M2 8c0 3.3137 2.68629 6 6 6 3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6Zm6-8C3.58172 0 0 3.58172 0 8c0 4.4183 3.58172 8 8 8 4.4183 0 8-3.5817 8-8 0-4.41828-3.5817-8-8-8Z'
          />
        </Box>
      )}
      <StyledInnerRadioCircle
        isSelected={isSelected}
        w={2}
        h={2}
        position='absolute'
        top='4px'
        left='4px'
        bg='fg/major-on-color'
        borderRadius='full'
      />
    </Box>
  )
}

const getRadioBackground = (isSelected: boolean, isDisabled: boolean): ThemeColors | undefined => {
  if (!isSelected) {
    return undefined
  }
  if (isDisabled) {
    return 'bg/select-item-major-checked-disabled'
  }
  return 'bg/select-item-major-checked'
}

const getRadioShadow = (isFocused: boolean): ThemeShadows | undefined => {
  if (isFocused) {
    return 'border/focus-indicator'
  }
  return undefined
}

const StyledInnerRadioCircle = styled(Box)<{ isSelected: boolean }>`
  transition: all 0.2s ease;
  transform: scale(${({ isSelected }) => (isSelected ? 1 : 0)});
`
